// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Types
import type { ChartType } from '@/lib/analytics/charts/chart.type';
import { SIZE_50 } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

// Components
import { BarGroupedChart } from '@/components/composite/Charts/BarGroupedChart';

export const postHistoryConfig: ChartType<typeof BarGroupedChart> = {
    title: 'chart.tiktok.post_history',
    tooltip: 'chart.tiktok.post_history_tooltip',
    id: 'posts_history',
    margin: { left: -30, bottom: 25, right: 10 },
    name: {
        date: 'date',
        value: 'chart.tiktok.post_history_name'
    },
    social: TIKTOK_BUSINESS,
    color: {
        value: 'blue'
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: BarGroupedChart,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
